import { createStore } from "effector";
import {
  setAreOfficesLoading,
  setOffices,
  setSelectedOfficeInStore,
  setSelectedOffices,
} from "@state/offices/OfficesEvents";
import { UserOffice, UserOfficesHandler } from "@type/core/auth/auth.types";

export const userOfficesStore = createStore<UserOfficesHandler>({
  areOfficesLoading: false,
  offices: [],
  selectedOffices: [],
  selectedOffice: undefined,
})
  .on<UserOffice[]>(
    setOffices,
    (state: UserOfficesHandler, payload: UserOffice[]) => {
      return { ...state, offices: payload };
    },
  )
  .on<UserOffice[]>(
    setSelectedOffices,
    (state: UserOfficesHandler, payload: UserOffice[]) => {
      return { ...state, selectedOffices: payload };
    },
  )
  .on<boolean>(
    setAreOfficesLoading,
    (state: UserOfficesHandler, payload: boolean) => {
      state.areOfficesLoading = payload;
      return state;
    },
  )
  .on<UserOffice>(
    setSelectedOfficeInStore,
    (state: UserOfficesHandler, payload: UserOffice) => {
      return { ...state, selectedOffice: payload ?? null };
    },
  );
